import {TooltipBaseService} from "../tooltip-base.service";
import {IOnBoardingTooltipsService} from "./on-boarding-tooltips.service.interface";
import {IOnBoardingTooltipsContainer} from "./on-boarding-tooltips-container.interface";
import {ITooltipModel} from "../tooltip-base/tooltip-model.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {FreePlayOnBoardingTooltipModel} from "./free-play/free-play.on-boarding-tooltip.model";
import {makeObservable, observable, runInAction} from "mobx";
import {IosPwaOnBoardingTooltipModel} from "./pwa/ios-pwa.on-boarding-tooltip.model";
import {ControlCenterOnBoardingTooltipModel} from "./control-center/control-center.on-boarding-tooltip.model";
import {SetTimeoutType} from "../../../../common/types/set-timeout-type";

export class OnBoardingTooltipsService extends TooltipBaseService implements IOnBoardingTooltipsService, IOnBoardingTooltipsContainer {
    constructor(services: IServiceFactoryExtended) {
        super(services);
        makeObservable(this);
        this._migrateOldStorageKeys();

        runInAction(() => {
            this._toolTips.push(new ControlCenterOnBoardingTooltipModel(this, services));
            this._toolTips.push(new FreePlayOnBoardingTooltipModel(this, services));
            this._toolTips.push(new IosPwaOnBoardingTooltipModel(this, services));
        });

        let enableOnBoardingTooltipsTimer: SetTimeoutType;
        this.reaction(() => this.services.user.isAuthorized, (isAuthorized) => {
            if(isAuthorized) {
                //We use this timeout to give the chance to toasters to appear before.
                //For example on Sweden after login we show a toaster, but because we load the iziToast library async this will make
                //the toaster to appear after on boarding tooltips, but we want to give precedence to the toaster over the tooltip.
                // We don't use iziToast enymore, would that still be relevant??
                enableOnBoardingTooltipsTimer = setTimeout(() => {
                    runInAction(() => {
                       this.isOnBoardingEnabled = true;
                    });
                }, 3000);
            } else {
                clearTimeout(enableOnBoardingTooltipsTimer);
                runInAction(() => {
                    this.isOnBoardingEnabled = false;
                });
            }
        }, {
            fireImmediately: true
        })


    }

    @observable.ref
    isOnBoardingEnabled: boolean = false;

    get toolTips(): ITooltipModel[] {
        //we use filter and not find because we want this getter to depend on all observables in the _toolTips array
        const visibleTooltips = this._toolTips.filter(tt => tt.shouldDisplay());
        if(visibleTooltips.length > 0) {
            return [visibleTooltips[0]];
        }
        return [];
    }

    private _migrateOldStorageKeys(): void {
        let storedValue = this.services.localStorage.getItem('orbit_free_play_tooltip_is_displayed_in_session');
        if(storedValue) {
            this.services.localStorage.setItem('free_play_on_boarding_tooltip.sessionDisplayCount', storedValue === 'true' ? 1 : 0);
            this.services.localStorage.removeItem('orbit_free_play_tooltip_is_displayed_in_session');
        }

        storedValue = this.services.localStorage.getItem('orbit_free_play_tooltip_displayed_number');
        if(storedValue) {
            this.services.localStorage.setItem('free_play_on_boarding_tooltip.totalDisplayCount', storedValue);
            this.services.localStorage.removeItem('orbit_free_play_tooltip_displayed_number');
        }

        storedValue = this.services.localStorage.getItem('orbit-pwa-ios-shown-install-tooltip-count');
        if(storedValue) {
            this.services.localStorage.setItem('ios-pwa_on_boarding_tooltip.totalDisplayCount', storedValue);
            this.services.localStorage.removeItem('orbit-pwa-ios-shown-install-tooltip-count');
        }

    }
}